<div class="forms-check-indicator" [ngClass]="{'is-checked': checked}">
    <div class="forms-check-indicator__inner">
        <shared-icon [icon]="icon" *ngIf="checked" class="forms-check-indicator__icon"></shared-icon>
    </div>
</div>